import { render, staticRenderFns } from "./fanQiHs.vue?vue&type=template&id=199a5ebe&scoped=true&"
import script from "./fanQiHs.vue?vue&type=script&lang=js&"
export * from "./fanQiHs.vue?vue&type=script&lang=js&"
import style0 from "./fanQiHs.vue?vue&type=style&index=0&id=199a5ebe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a5ebe",
  null
  
)

export default component.exports